import {createAction} from '@reduxjs/toolkit'

export const registrationButtonClicked = createAction('REGISTRATION_BUTTON_CLICKED')
